import { Store } from '@reduxjs/toolkit';
import { ProductRenderer } from '@/renderer/ProductRenderer';
import { ThreeEvent } from '@/renderer/types';
import { creatorActions } from './slices/creatorSlice';

const renderer = ProductRenderer.getInstance();

export function initCreatorListeners(store: Store) {
	for (const event of Object.values(ThreeEvent)) {
		renderer.emitter.on(event, (data) => {
			store.dispatch(
				creatorActions.handleRendererEvent({
					type: event,
					data,
				})
			);
		});
	}
}
